"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useAuth } from "@/lib/auth-context";

export default function DiagnosticMenu() {
  const { user, isSudo } = useAuth();
  const [open, setOpen] = useState(false);

  // Capture + deferred dismiss so clicks anywhere (incl. stopPropagation parents) close us.
  useEffect(() => {
    if (!open) return;
    const dismiss = () => { setTimeout(() => setOpen(false), 0); };
    const id = requestAnimationFrame(() => {
      document.addEventListener("click", dismiss, true);
    });
    return () => {
      cancelAnimationFrame(id);
      document.removeEventListener("click", dismiss, true);
    };
  }, [open]);

  const pathname = usePathname();
  const active = pathname.startsWith("/diagnostic");

  if (!user) return null;

  return (
    <div className="relative">
      <button
        onClick={(e) => {
          e.stopPropagation();
          setOpen(!open);
        }}
        className={`transition-colors select-none ${
          active
            ? "text-white [text-shadow:0_0_8px_#fff,0_0_16px_#fff,0_0_30px_var(--color-accent),0_0_50px_var(--color-accent)]"
            : "text-muted hover:text-accent"
        }`}
      >
        Noodling
      </button>
      {open && (
        <div
          className="dropdown-panel absolute left-0 top-full mt-1 min-w-[160px]"
          onClick={(e) => e.stopPropagation()}
        >
          {isSudo && (
            <>
          <Link
            href="/diagnostic/epitm"
            className="dropdown-item"
            onClick={() => setOpen(false)}
          >
            eP(ITM)
          </Link>
          <Link
            href="/diagnostic/apitm"
            className="dropdown-item"
            onClick={() => setOpen(false)}
          >
            aP(ITM)
          </Link>
          <Link
            href="/diagnostic/0dte"
            className="dropdown-item"
            onClick={() => setOpen(false)}
          >
            0DTE
          </Link>
          <Link
            href="/diagnostic/option-chains"
            className="dropdown-item"
            onClick={() => setOpen(false)}
          >
            Option Chains
          </Link>
          <Link
            href="/diagnostic/threshold"
            className="dropdown-item !text-red"
            onClick={() => setOpen(false)}
          >
            Threshold
          </Link>
          <Link
            href="/diagnostic/patterns"
            className="dropdown-item"
            onClick={() => setOpen(false)}
          >
            Patterns
          </Link>
          <Link
            href="/diagnostic/pattern-backtest"
            className="dropdown-item"
            onClick={() => setOpen(false)}
          >
            Pattern Backtesting
          </Link>
            </>
          )}
          <Link
            href="/diagnostic/historical-data"
            className="dropdown-item"
            onClick={() => setOpen(false)}
          >
            Historical Data
          </Link>
        </div>
      )}
    </div>
  );
}
